import { render, staticRenderFns } from "./OrcamentoInformacaoAdicional.vue?vue&type=template&id=66d841bc&scoped=true"
import script from "./OrcamentoInformacaoAdicional.vue?vue&type=script&lang=js"
export * from "./OrcamentoInformacaoAdicional.vue?vue&type=script&lang=js"
import style0 from "./OrcamentoInformacaoAdicional.vue?vue&type=style&index=0&id=66d841bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d841bc",
  null
  
)

export default component.exports